import { render, staticRenderFns } from "./userIpBlack.vue?vue&type=template&id=22521018&scoped=true&"
import script from "./userIpBlack.vue?vue&type=script&lang=js&"
export * from "./userIpBlack.vue?vue&type=script&lang=js&"
import style0 from "./userIpBlack.vue?vue&type=style&index=0&id=22521018&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22521018",
  null
  
)

export default component.exports